import { encode } from "~/components/svgEncode"

export default ({ neuron, layer, type }) => {
  if ((window.location + "").indexOf("localhost") === -1) return

  const $body = document.getElementsByTagName("body")[0]
  const copyToClipboard = function(secretInfo) {
    const $tempInput = document.createElement("INPUT")
    $body.appendChild($tempInput)
    $tempInput.setAttribute("value", secretInfo)
    $tempInput.select()
    document.execCommand("copy")
    $body.removeChild($tempInput)
  }

  copyToClipboard(encode(type, layer, neuron))
}
